import React from 'react';

import get from 'get-value';

import Text from '../../Text';
import DateOutput from '../../../utils/DateOutput';
import { PhoneNumberOutput } from '../../../utils/PhoneNumber';
import { CurrencyOutput, currencyOutputNumber } from '../../../utils/CurrencyOutput';
import { DocumentStr } from 'utils/Document';

export const TableItem = (propsItem: any) => {

  const { item, modelItem, trackingKeyProps, customProps } = propsItem;
  const validString = get(item, modelItem.key);

  const TextTableItem = () => {

    const classIsTextWrap = modelItem.label === "Empresa" ? "text-wrap" : "";

    if (modelItem.type === 'date/hour') {
      return (
        <Text size={12} className="color-blue-gray">
          <DateOutput dateStr={validString} />
        </Text>
      );
    }

    if (modelItem.type === 'date') {
      return (
        <Text size={12} className="color-blue-gray">
          <DateOutput dateStr={validString} patternStr="dd/MM/yyyy" />
        </Text>
      );
    }

    if (modelItem.type === 'currency') {
      return (
        <Text size={12} showTip={true}
          showTipContent={currencyOutputNumber(Number(validString))} className="color-blue-gray">
          <CurrencyOutput value={Number(validString)} />
        </Text>
      );
    }

    if (modelItem.type === 'phone') {
      return (
        <Text
          size={12}
          className="color-blue-gray"
          showTip
          showTipContent={PhoneNumberOutput(validString)}
        >
          {PhoneNumberOutput(validString)}
        </Text>
      );
    }

    if (modelItem.type === 'cnpj') {
      return (
        <Text size={12} className="color-blue-gray">
          {DocumentStr({
            type: 'cnpj',
            value: validString,
          })}
        </Text>
      );
    }

    return (
      <Text
        size={12}
        className={`color-blue-gray ${classIsTextWrap}`}
        showTip
        showTipContent={validString}
      >
        {validString}
      </Text>
    );
  };

  const TableItemCondition = () => {
    if (modelItem.key &&
      (typeof validString === 'string' || typeof validString === 'number') &&
      !modelItem.Component) {
      return <TextTableItem />;
    }

    if (modelItem.Component) {
      const { Component } = modelItem;

      const dataTracking = {
        ...item,
        ...customProps,
      };

      return <Component trackingKey={trackingKeyProps} {...dataTracking} />;
    }

    return (
      <Text className="color-blue-gray" size={12}>
        -
      </Text>
    );
  };

  return (
    <TableItemCondition />
  );
};